import { SafeResourceUrl } from '@angular/platform-browser'
import { ModalType } from './enum/modal.enum'

export class Modal {
  type: ModalType
  data: ModalData
}

export class ModalData {
  title: string
  videoHostingService?: string
  videoURL?: SafeResourceUrl
  error?: string
}
